module.exports = __webpack_public_path__ + "assets/img/free_17.d560948c.png";